import { useMutation } from "@tanstack/react-query";
import {
  loginByPhoneApi,
  otpVerifyApi,
  registerByPhoneApi,
} from "@/api/end-points/auth";

export const useLoginByPhone = (useQueryOptions) => {
  const { onSuccess = () => {}, onError = () => {} } = useQueryOptions || {};

  return useMutation(loginByPhoneApi, {
    onSuccess: (res) => {
      onSuccess({
        status: res.status,
        data: res.data?.data,
        message: res.data.message,
      });
    },
    onError: (error) => {
      onError({
        status: error.response.status,
        errors: error.response.data?.errors,
        message: error.message,
      });
    },
  });
};

export const useOtpVerify = (useQueryOptions) => {
  const { onSuccess = () => {}, onError = () => {} } = useQueryOptions || {};

  return useMutation(otpVerifyApi, {
    onSuccess: (res) => {
      onSuccess({
        status: res.status,
        data: res.data?.data,
        message: res.data.message,
      });
    },
    onError: (error) => {
      onError({
        status: error.response.status,
        errors: error.response.data?.errors,
        message: error.message,
      });
    },
  });
};

export const useRegisterByPhone = (useQueryOptions) => {
  const { onSuccess = () => {}, onError = () => {} } = useQueryOptions || {};

  return useMutation(registerByPhoneApi, {
    onSuccess: (res) => {
      onSuccess({
        status: res.status,
        data: res.data?.data,
        message: res.data.message,
      });
    },
    onError: (error) => {
      onError({
        status: error.response.status,
        errors: error.response.data?.errors,
        message: error.message,
      });
    },
  });
};
